import type { GQL_ID } from '@@partner:types:graphql'
import type { Stories } from '@@partner:types:app'

import { gql, useMutation } from '@apollo/client'

import { SHORTCUT_STORIES_FIELDS } from '@@partner:graphql/shortcuts'

export interface StoriesInfoInput {
  id?: GQL_ID
  preview_id?: GQL_ID
  name?: string
  status?: number
  sort_order?: number
  preview?: {
    url?: string
  }
  created_at: Date
  updated_at: Date
  slides?: {
    id?: GQL_ID
    name?: string
    status?: number
    image_id?: GQL_ID
    url?: string
    sort_order?: number
    image?: {
        url?: string
    }
  }
}

export interface SaveStories {
  storyInfo: Stories
}
export interface SaveStoriesVariables {
  storyInfo: StoriesInfoInput
}

export const GQL_MUTATION_SAVE_STORY = gql`
  mutation($newData: MarketingStoryInfoInput!, $upsert: Boolean!) {
    storyInfo: updateMarketingStoryInfo(newData: $newData, upsert: $upsert) {
      ${SHORTCUT_STORIES_FIELDS}
    }
  }
`

export const useMutateSaveStory = () =>
  useMutation<SaveStories, SaveStoriesVariables>(
    GQL_MUTATION_SAVE_STORY
  )
